import { createFileRoute } from "@tanstack/react-router";
import { goalsSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/_protected/goals/")({
  head: () => ({
    meta: [{ title: "月度目标设定 · imiker CRM" }],
  }),
  validateSearch: goalsSearchSchema
});
